export const clickedOn = (action, eventLbl) => {
  let gtag = window.gtag || function () {};

  gtag("event", action, {
    event_category: "Job Offers",
    event_label: eventLbl,
  });
};
